// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#print-order-form-modal>div[data-v-11d9e4fc]{transition:max-width .35s ease}#print-order-step-2[data-v-11d9e4fc]{display:none}.sent-buttons .left[data-v-11d9e4fc]{position:absolute;left:15px}@media (max-width:575px){.sent-buttons[data-v-11d9e4fc]{width:100%}.sent-buttons .left[data-v-11d9e4fc]{position:relative;left:0;display:block;width:100%}.sent-buttons .btn-xs-block[data-v-11d9e4fc]{width:100%}}", ""]);
// Exports
module.exports = exports;
